(function () {
  const submittedKey = 'puzzery_event_offer_submitted';

  function getDateParts(dateValue) {
    const match = (dateValue || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;

    return {
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
    };
  }

  function localizeDate(dateLabel) {
    if (!dateLabel) return;

    const dateParts = getDateParts(dateLabel.getAttribute('datetime'));
    if (!dateParts) return;

    try {
      dateLabel.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }).format(new Date(dateParts.year, dateParts.month - 1, dateParts.day, 12));
    } catch (error) {
      // Keep the ISO date from Liquid when localized date formatting is not available.
    }
  }

  function initializeCountdown(countdown) {
    if (!countdown) return;

    const dateParts = getDateParts(countdown.dataset.endDate);
    if (!dateParts) return;

    const { year, month, day } = dateParts;
    const closesAt = new Date(year, month - 1, day + 1);
    const daysNode = countdown.querySelector('[data-countdown-days]');
    const hoursNode = countdown.querySelector('[data-countdown-hours]');
    const minutesNode = countdown.querySelector('[data-countdown-minutes]');
    const secondsNode = countdown.querySelector('[data-countdown-seconds]');

    let timer;

    function updateCountdown() {
      if (!countdown.isConnected) {
        if (timer) window.clearInterval(timer);
        return;
      }

      const remaining = Math.max(0, closesAt.getTime() - Date.now());
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      if (daysNode) daysNode.textContent = String(days).padStart(2, '0');
      if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
      if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
      if (secondsNode) secondsNode.textContent = String(seconds).padStart(2, '0');

      if (remaining === 0 && timer) window.clearInterval(timer);
    }

    updateCountdown();
    timer = window.setInterval(updateCountdown, 1000);
  }

  function initializeEventOffer(root) {
    if (!root || root.dataset.eventOfferReady === 'true') return;

    root.dataset.eventOfferReady = 'true';
    root.querySelectorAll('[data-event-offer-localized-date]').forEach(localizeDate);
    initializeCountdown(root.querySelector('[data-event-offer-countdown]'));

    const form = root.querySelector('.event-offer__form');
    if (!form) return;

    const tagsInput = form.querySelector('[data-event-offer-tags]');
    const creatorToggle = form.querySelector('[data-event-offer-creator]');
    const handleField = form.querySelector('[data-event-offer-handle-field]');
    const handleInput = form.querySelector('[data-event-offer-handle]');
    const honeypot = form.querySelector('[data-event-offer-honeypot]');
    const formState = form.querySelector('[data-event-offer-form-state]');
    const successState = form.querySelector('[data-event-offer-success]');

    function showSuccess() {
      if (formState) formState.hidden = true;
      if (successState) {
        successState.hidden = false;
        successState.focus();
      }
    }

    function updateTags() {
      if (!tagsInput) return;

      const tags = (tagsInput.dataset.baseTags || '')
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean);

      if (creatorToggle && creatorToggle.checked) {
        const creatorTag = (tagsInput.dataset.creatorTag || '').trim();
        const handle = handleInput ? handleInput.value.trim() : '';

        if (creatorTag) tags.push(creatorTag);
        if (handle) tags.push(handle);
      }

      tagsInput.value = [...new Set(tags)].join(', ');
    }

    function updateCreatorFields() {
      if (!creatorToggle || !handleField || !handleInput) return;

      const isCreator = creatorToggle.checked;
      handleField.hidden = !isCreator;
      handleInput.disabled = !isCreator;
      handleInput.required = isCreator;
      creatorToggle.setAttribute('aria-expanded', String(isCreator));

      if (!isCreator) {
        handleInput.value = '';
        handleInput.setCustomValidity('');
      }

      updateTags();
    }

    if (creatorToggle) creatorToggle.addEventListener('change', updateCreatorFields);
    if (handleInput) handleInput.addEventListener('input', updateTags);

    form.addEventListener('submit', function (event) {
      updateTags();

      if (honeypot && honeypot.value) {
        event.preventDefault();
        showSuccess();
        return;
      }

      try {
        sessionStorage.setItem(submittedKey, 'true');
      } catch (error) {
        // The native form still works when browser storage is not available.
      }
    });

    updateCreatorFields();

    if (window.location.search.includes('customer_posted=true')) {
      let submittedHere = false;

      try {
        submittedHere = sessionStorage.getItem(submittedKey) === 'true';
        sessionStorage.removeItem(submittedKey);
      } catch (error) {
        // Shopify's Liquid success state remains the fallback.
      }

      if (submittedHere) showSuccess();
    }
  }

  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-event-offer]')) initializeEventOffer(scope);
    scope.querySelectorAll('[data-event-offer]').forEach(initializeEventOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
